import { render, staticRenderFns } from "./QuizDiabetesManagment.vue?vue&type=template&id=1fd93362"
import script from "./QuizDiabetesManagment.vue?vue&type=script&lang=js"
export * from "./QuizDiabetesManagment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports